export const DRAG_START_REQUEST = 'si-overlay-drag-start-request';
export const ON_OVERLAY_DRAG = 'si-overlay-drag';
export const END_OVERLAY_DRAG = 'si-overlay-drag-end';